<template>
  <div>
    <el-button @click="dialogVisibles = true" size="small">内容设置</el-button>
    <el-dialog
      :visible.sync="dialogVisibles"
      title="机器人基本参数设置"
      width="800px"
      @close="closeDialog"
      @open="onOpen"
    >
      <el-form :model="baseForm" ref="baseForm" label-width="200px">
        <el-form-item label="交易对" prop="pair">
          <template>
            <span>{{ val.pair }}</span>
          </template>
        </el-form-item>
        <el-form-item
          label="数量系数"
          prop="amountScore"
          v-if="type === 'mirrorBargain'"
        >
          <el-input-number v-model="baseForm.amountScore"></el-input-number>
        </el-form-item>
        <el-form-item
          label="价格系数"
          prop="valvePrice"
          v-if="type === 'mirrorBargain'"
        >
          <el-input-number v-model="baseForm.valvePrice"></el-input-number>
        </el-form-item>
        <el-form-item
          label="运行频率(毫秒)"
          prop="delay"
          v-if="type === 'mirrorBargain'"
        >
          <el-input-number v-model="baseForm.delay"></el-input-number>
        </el-form-item>
        <el-form-item label="机器人ID" v-if="type === 'mirror'">
          <span>{{ baseForm.robotUserId }}</span>
        </el-form-item>
        <el-form-item
          label="买单数量系数"
          prop="buyAmountScore"
          v-if="type === 'mirror'"
        >
          <el-input-number v-model="baseForm.buyAmountScore"></el-input-number>
        </el-form-item>
        <el-form-item
          label="买单价格系数"
          prop="buyPriceScore"
          v-if="type === 'mirror'"
        >
          <el-input-number v-model="baseForm.buyPriceScore"></el-input-number>
        </el-form-item>
        <el-form-item
          label="卖单数量系数"
          prop="sellAmountScore"
          v-if="type === 'mirror'"
        >
          <el-input-number v-model="baseForm.sellAmountScore"></el-input-number>
        </el-form-item>
        <el-form-item
          label="卖单价格系数"
          prop="sellPriceScore"
          v-if="type === 'mirror'"
        >
          <el-input-number v-model="baseForm.sellPriceScore"></el-input-number>
        </el-form-item>
        <el-form-item
          label="初始余额"
          prop="initBalance"
          v-if="type === 'mirror'"
        >
          <el-input-number v-model="baseForm.initBalance"></el-input-number>
        </el-form-item>
        <el-form-item
          label="初始镜像系数"
          prop="original"
          v-if="type === 'mirror'"
        >
          <el-input-number v-model="baseForm.original"></el-input-number>
        </el-form-item>
        <el-form-item
          label="价格上下限系数"
          prop="cof"
          v-if="type === 'mirror'"
        >
          <el-input-number v-model="baseForm.cof"></el-input-number>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibles = false">取消</el-button>
        <el-button type="primary" @click="handleSave()">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex';

export default {
  name: 'CreateContent',
  props: ['val', 'type'],
  data() {
    return {
      dialogVisibles: false,
      baseForm: {
        robotUserId: this.val.robotUserId,
        pair: this.val.pair,
        amountScore: this.val.amountScore,
        valvePrice: this.val.valvePrice,
        delay: this.val.delay,
        buyAmountScore: this.val.buyAmountScore,
        buyPriceScore: this.val.buyPriceScore,
        buy_price_score: this.val.buy_price_score,
        sellAmountScore: this.val.sellAmountScore,
        sellPriceScore: this.val.sellPriceScore,
        initBalance: this.val.initBalance,
        original: this.val.original,
        cof: this.val.cof
      }
    };
  },
  methods: {
    ...mapActions('robotpingSetting', ['setBargain', 'getList']),
    onOpen() {
      this.baseForm = Object.assign({}, this.val);
    },
    closeDialog() {
      this.$refs['baseForm'].resetFields();
    },
    handleSave() {
      this.setBargain({ type: this.type, content: this.baseForm }).then(() => {
        this.$message.success('成功！');
        this.getList({ style: this.type, type: 1 });
        this.dialogVisibles = false;
      });
    }
  }
};
</script>

<style lang="less" scoped></style>
